import styled from "styled-components";

export const ItemCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 10px 0;
  box-sizing: border-box;
`;

export const ItemCardImage = styled.img`
  width: 90px;
  height: 90px;
  border-radius: 10px;

  @media (max-width: 451px) {
    width: 50px;
    height: 50px;
  }

  @media (max-width: 351px) {
    width: 30px;
    height: 30px;
  }
`;

export const ItemInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
`;

export const ItemName = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 0 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;

  @media (max-width: 451px) {
    max-width: 150px;
  }

  @media (max-width: 351px) {
    max-width: 80px;
  }
`;

export const ItemPrice = styled.div`
  font-size: 15px;
  font-weight: 500;
  margin: 10px 0 0 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;

  @media (max-width: 451px) {
    max-width: 150px;
  }

  @media (max-width: 351px) {
    max-width: 80px;
  }
`;